import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 40 40" {...props}>
    <path
      d="M30.6,17.7l-6-0.4c0,0,0,0,0,0c-1.9,0-1.9-2.4-1.9-3.7c-0.1-0.2-1.1-0.5-2.1-0.5h-0.5c-1,0-1.9,0.3-2.1,0.5
      c0,1.3,0,3.7-2,3.7l-5.9,0.4c0,0,0,0,0,0C9,17.7,8,17,7.8,16c-0.3-1.4-0.5-4.1,1.3-6.3c1.9-2.4,5.6-3.6,10.9-3.6h0.7
      c5.3,0,8.9,1.2,10.9,3.6c1.8,2.3,1.6,4.9,1.3,6.3C32.7,17,31.7,17.7,30.6,17.7z M24.8,15.3l5.9,0.4c0.1,0,0.2-0.1,0.3-0.1
      c0.2-1,0.4-3-0.9-4.6c-1.5-1.9-4.7-2.9-9.3-2.9H20c-4.6,0-7.8,1-9.3,2.9c-1.3,1.6-1.1,3.6-0.9,4.6h0c0,0,0.1,0.1,0.3,0.1l5.8-0.4
      c0.1-0.2,0.1-0.7,0.1-1.7c0-0.6,0.2-1.1,0.6-1.5c0.8-0.8,2.3-1,3.2-1c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0
      c0,0,0.1,0,0.1,0c1,0,2.4,0.3,3.2,1c0.4,0.4,0.6,0.9,0.6,1.5C24.6,14.6,24.7,15.1,24.8,15.3z M24.6,15.3L24.6,15.3
      C24.6,15.3,24.6,15.3,24.6,15.3z"
    />
    <path
      style={{ transform: 'translateY(33%)' }}
      d="M30.6,17.7l-6-0.4c0,0,0,0,0,0c-1.9,0-1.9-2.4-1.9-3.7c-0.1-0.2-1.1-0.5-2.1-0.5h-0.5c-1,0-1.9,0.3-2.1,0.5
      c0,1.3,0,3.7-2,3.7l-5.9,0.4c0,0,0,0,0,0C9,17.7,8,17,7.8,16c-0.3-1.4-0.5-4.1,1.3-6.3c1.9-2.4,5.6-3.6,10.9-3.6h0.7
      c5.3,0,8.9,1.2,10.9,3.6c1.8,2.3,1.6,4.9,1.3,6.3C32.7,17,31.7,17.7,30.6,17.7z M24.8,15.3l5.9,0.4c0.1,0,0.2-0.1,0.3-0.1
      c0.2-1,0.4-3-0.9-4.6c-1.5-1.9-4.7-2.9-9.3-2.9H20c-4.6,0-7.8,1-9.3,2.9c-1.3,1.6-1.1,3.6-0.9,4.6h0c0,0,0.1,0.1,0.3,0.1l5.8-0.4
      c0.1-0.2,0.1-0.7,0.1-1.7c0-0.6,0.2-1.1,0.6-1.5c0.8-0.8,2.3-1,3.2-1c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.4,0c0.2,0,0.3,0,0.4,0
      c0,0,0.1,0,0.1,0c1,0,2.4,0.3,3.2,1c0.4,0.4,0.6,0.9,0.6,1.5C24.6,14.6,24.7,15.1,24.8,15.3z M24.6,15.3L24.6,15.3
      C24.6,15.3,24.6,15.3,24.6,15.3z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Phones.jsx